import { Component, OnInit, ViewChild , HostListener} from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { Subject } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import { GrantsDatashareService } from 'src/app/services/grants/grants-datashare.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HeadService } from 'src/app/services/common/headservice';
import * as $ from 'jquery';
import { DateObject, Document_Upload_File, ModuleMenu, SCREEN_CONTROL, SCREEN_RESPONSE, ScreenResponseModel } from 'src/app/models/common';
import { IDeactivateComponent } from 'src/app/services/common/deactivate-guard.service';
import { serviceConstants } from 'src/app/constants/service.constants';
import { FileService } from 'src/app/services/file.service';
import { DatePipe } from '@angular/common';
import * as _ from 'lodash';

@Component({
  selector: 'app-grants-general-information',
  templateUrl: './grants-general-information.component.html',
  styleUrls: ['./grants-general-information.component.scss']
})
export class GrantsGeneralInformationComponent implements OnInit, IDeactivateComponent {

  permission: string = "";
  staticformFields: any;
  IS_PREIOR_REQ: any[];
  IS_AFFILIATE_PRO: any[];
  IS_PREV_YEAR: any[];
  IS_EXHIBIT_OPPORTUNITY: any[];
  IS_OTH_CORPORATES: any[];
  action: Subject<any> = new Subject();
  userType: string = "";
  heading: string;
  operations: any = [];
  ApplicationID: any;
  menudata: ModuleMenu;
  Application_Type_ID: string = "";
  Record_ID:string;
  ////////////////////

  IsFormToched = false;
  isDateModified: boolean = false;
  Full_Date: DateObject;
  tooltipValue: string;

  submittedresponse: SCREEN_RESPONSE[] = [];
  isSubmitVisible : boolean = false;
  disableSave: boolean = false;
  Grantsapp: any;
  createdUser: any;
  ScreenSubmitStatus: boolean = false;
  user : any;
  IsRecordSaved:boolean = false;
  Id : string;
  status : number = 0;
  ScreenName:string = '';
  Currency_ID: string = '';

  constructor(
    public commonService: CommonService,
    private userService: UserService,
    private DatashareSerivce: GrantsDatashareService,
    private summaryService: GrantsSummaryService,
    public route: ActivatedRoute,
    private router: Router,
    private header: HeadService,
    public fileService: FileService,
    public datepipe: DatePipe
  ) {
    this.Application_Type_ID = route.snapshot.queryParams['ApplicationType'];
  }

  @HostListener('input', ['$event'])
  onInputChange(event: any) {
    this.IsFormToched = true;
  }

  ngOnInit() {
    if (this.Application_Type_ID == null || this.Application_Type_ID == undefined || this.Application_Type_ID == "") {
      this.DatashareSerivce.Application_Type_ID.subscribe(x => {
        this.Application_Type_ID = x;
      });
    }
     if (this.Currency_ID == null || this.Currency_ID == undefined || this.Currency_ID == "") {
      this.DatashareSerivce.Currency_ID.subscribe(x => {
        this.Currency_ID = x;
      });
    }
    this.Grantsapp = this.commonService.getGrantsApp();
    this.user = this.userService.getUserDetais();
    this.userType = this.userService.getUserType();
    this.DatashareSerivce.GrantApplicationID.subscribe(x => {
      this.ApplicationID = x;
       this.GetScreenConfigControls('GC01');
    });  

    if(!this.isSubmitVisible){
      this.disableSave = false;
    }

    this.permission = this.commonService.getPagePermission("GC01").toLowerCase();
    if (this.permission == null || this.permission == undefined || this.permission == '') {
      const intervalId = setInterval(() => {
        this.permission = this.commonService.getPagePermission("GC01").toLowerCase();
        if (this.permission != null && this.permission != undefined && this.permission != '') {
          clearInterval(intervalId);
        }
      }, 1000);
    }
  }
 GetScreenConfigControls(screenCode: string) {
    this.commonService.GetScreenConfigControls(screenCode, this.ApplicationID, this.ApplicationID,(ScreenData) => {
      this.staticformFields = ScreenData["SCREEN_CONTROL"];
      this.ScreenName = ScreenData.NAME;
      this.getScreenDataEdit();
      if(this.Grantsapp?.STATUS > 1 ){
        this.isSubmitVisible = ScreenData.HAS_SAVE_SUBMIT == 1 ? true :false;       
      }  
    });
  }
 

  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode, this.ApplicationID)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
        this.IS_PREIOR_REQ = this.staticformFields.IS_PREIOR_REQ.GROUP_VALUES_LIST;
        this.IS_PREIOR_REQ = [{ label: "Select", value: null, checked: true }].concat(this.IS_PREIOR_REQ);
        this.IS_AFFILIATE_PRO = this.staticformFields.IS_AFFILIATE_PRO.GROUP_VALUES_LIST;
        this.IS_AFFILIATE_PRO = [{ label: "Select", value: null, checked: true }].concat(this.IS_AFFILIATE_PRO);
        this.IS_PREV_YEAR = this.staticformFields.IS_PREV_YEAR.GROUP_VALUES_LIST;
        this.IS_PREV_YEAR = [{ label: "Select", value: null, checked: true }].concat(this.IS_PREV_YEAR);
        this.IS_EXHIBIT_OPPORTUNITY = this.staticformFields.IS_EXHIBIT_OPPORTUNITY.GROUP_VALUES_LIST;
        this.IS_EXHIBIT_OPPORTUNITY = [{ label: "Select", value: null, checked: true }].concat(this.IS_EXHIBIT_OPPORTUNITY);
        this.IS_OTH_CORPORATES = this.staticformFields.IS_OTH_CORPORATES.GROUP_VALUES_LIST;
        this.IS_OTH_CORPORATES = [{ label: "Select", value: null, checked: true }].concat(this.IS_OTH_CORPORATES);
      });
  }

  onCallbackOperation(opr) {
    opr.callback(this.summaryService,null, this.DatashareSerivce);
  }
validateControls(): boolean {
    let isValid = true;
    let message = "";

    if(this.Grantsapp?.STATUS >= 2){
      this.staticformFields.forEach((item) => {
        if (item.IS_MANDATORY && item.IS_Dependent_Enabled == true && item.IS_Dependent_Display == true) {
          switch (item.CONTROL) {
            case 1:
            case 2:
            case 3:
            case 5:
            case 4:
            case 11:
              if (!item.ControlValue) {
                $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
              break;
            case 10:
                if (!(item.ControlValue) || (item.ControlValue != null && item.ControlValue.length == 0)) {
                  $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                  $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                  message += `Please enter ${item.LABEL} <br/>`;
                  isValid = false;
                }
              break;
            case 6:
              let seletedItem = "";
              for (let c = 0; c < item.SourceItems.length; c++) {
                if (item.SourceItems[c].Checked == true) {
                  if (seletedItem == "")
                    seletedItem = item.SourceItems[c].value;
                  else
                    seletedItem = seletedItem + "," + item.SourceItems[c].value;
                }
              }
              item.ControlValue = seletedItem;
              if(!item.ControlValue)
              {
                $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
              break;
            
            case 7:
              if (!item.ControlValue) {
                $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
              break;
            case 8:
              if (item.UploadFiles != null && item.UploadFiles != undefined && item.UploadFiles.length == 0) {
                $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
              break;
            case 9:
              break;
          }
        }
      });

      if (isValid) {
        let inactiveValueControls = this.commonService.checkInactiveRecordState(this.staticformFields);
        if (inactiveValueControls && inactiveValueControls.length > 0) {
          isValid = false;
          let dataMsg = inactiveValueControls.join("</br>");
          this.commonService.ValidationBanner(dataMsg);
        }
      }
    }  
    else {
      // Check at least one field value exists
      isValid = this.commonService.checkHasSingleControlValue(this.staticformFields);
      if (!isValid) {
        message += `Please enter at least one field. <br/>`;
      }
    }
      if (!isValid)
        this.commonService.ValidationBanner(message);
    return isValid;
  }
 
  SaveGeneralInfo(SaveType:string) {

    if(this.IsRecordSaved && this.user.ID != this.createdUser && this.ScreenSubmitStatus==false){    
      return this.commonService.ValidationBanner("This screen is currently being worked on by another user. You are not permitted to make changes at this time.");
     }

    if (this.validateControls()) {
      for (let i = 0; i < this.staticformFields.length; i++) {
          switch (this.staticformFields[i].CONTROL) {
            case 6:
              let seletedItem = "";
              for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
                if (this.staticformFields[i].SourceItems[c].Checked == true) {
                  if (seletedItem == "")
                    seletedItem = this.staticformFields[i].SourceItems[c].value;
                  else
                    seletedItem = seletedItem + "," + this.staticformFields[i].SourceItems[c].value;
                }
              }
              this.staticformFields[i].ANSWER = seletedItem;
              break;
            case 8:
              this.staticformFields[i].UploadedDocuments = [];
              if (this.staticformFields[i].UploadFiles) {
                for (let j = 0; j < this.staticformFields[i].UploadFiles.length; j++) {
                  if (this.staticformFields[i].UploadFiles[j].Status == "Add" || this.staticformFields[i].UploadFiles[j].Status == "Delete") {
                    this.staticformFields[i].UploadedDocuments.push(this.staticformFields[i].UploadFiles[j]);
                  }
                }
                this.staticformFields[i].ANSWER = null;
                this.staticformFields[i].ControlValue = null;
              }
              break;
            case 10:
              let SelectedValues = this.staticformFields[i].ControlValue;
              if (SelectedValues != null && SelectedValues != undefined && SelectedValues.length > 0) {
                this.staticformFields[i].ANSWER = SelectedValues.join(",");
              }
              else {
                this.staticformFields[i].ANSWER = "";
              }
              this.staticformFields[i].SUBFIELDNAME = "";
              //this.staticformFields[i].ControlValue = null;
              break;
            case 5:
              let controlanswer = this.staticformFields[i].ControlValue;
              if (controlanswer != null && controlanswer != "" && controlanswer != undefined) {
                let formd = this.datepipe.transform(new Date(controlanswer), 'dd-MMM-yyyy');
                this.staticformFields[i].ANSWER = formd;
              }
              else {
                this.staticformFields[i].ANSWER = controlanswer;
              }
              break;
            default:
              this.staticformFields[i].ANSWER = this.staticformFields[i].ControlValue;
              break;
          }
        }
        let uploadData = new FormData();
        let FinalControls=_.cloneDeep(this.staticformFields);
        FinalControls.forEach((item)=>{
          switch (item.CONTROL) {
            case 10:
              item.ControlValue=null;
              break;
          }
        });
        uploadData.append("ScreenControlsData", JSON.stringify(FinalControls));
        uploadData.append("Appid", this.ApplicationID);
        uploadData.append("ModuleID", "4");
        uploadData.append("Is_fromGeneralInformation", "yes");
        uploadData.append("APPLICATION_TYPE_ID",this.Application_Type_ID)
        uploadData.append("Currency_ID",this.Currency_ID)
        if (SaveType == "Save") {
          if(this.isSubmitVisible == true && this.Grantsapp?.STATUS > 1 && this.ScreenSubmitStatus == false) {
            uploadData.append("SUBMIT_STATUS", "0");

          } 
          else {
            uploadData.append("SUBMIT_STATUS", "1");
          }
        } else{
          uploadData.append("SUBMIT_STATUS", "1");

        }

      if (this.ApplicationID == "" || this.ApplicationID == undefined) {
        this.summaryService.SaveCMEGeneralInfo("api/GMAPPCME/Insert", uploadData).subscribe((result) => {
          this.IsFormToched = false;
          var tempID = result.TransactionID;
          this.ApplicationID = result.Data;
          this.DatashareSerivce.setGrantApplicationID(this.ApplicationID);
          this.commonService.SuccessBanner(this.ScreenName + " saved successfully");
          this.commonService.refreshApplicationPage(this.ApplicationID,'grants');
        });
      }
      else {
          uploadData.append("RecordID",this.ApplicationID);
        this.summaryService.SaveCMEGeneralInfo("api/GMAPPCME/Update", uploadData).subscribe((result) => {
          this.IsFormToched = false;
          if (result.Status === 0 || result.ErrorCode === "NOCHANGES") {
            if (result.ErrorCode === "NOCHANGES"){
                  this.getScreenDataEdit();
                  this.commonService.ValidationBanner(result.Message);
            }
            else {
              this.getScreenDataEdit();
              this.commonService.SuccessBanner(this.ScreenName + " saved successfully");
            }
          }
          else {
            this.getScreenDataEdit();
            this.commonService.ValidationBanner(result.Message);
          }
        });
      }
    }
  }

 

  redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri]));
  }

  canExit() {
    if (this.IsFormToched) {
      return this.commonService.CanDeactivateBanner();
    }
    else {
      return Promise.resolve(true);
    }
  }

  //////////////////////////
  singleonChange($event, question) {
    this.IsFormToched = true;
    this.UpdateParentChildDetails(question);
    this.ApplyConditions($event, question, "Y");
  }

  ApplyConditions($event, question, makeNull) {
    let value = $event.value;
    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }
    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];

    question.Control_Condtions.forEach((item) => {
      if (item.Mapped_Control_Value == value) {
        item.ConditionsList.forEach((otemCon) => {
          switch (otemCon.Mapped_Condtion) {
            case "1": //display
              if (displayControlIDS.length == 0) {
                displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disCntrIds && disCntrIds.length > 0) {
                  disCntrIds.forEach((id) => {
                    if (!displayControlIDS.includes(id)) {
                      displayControlIDS.push(id);
                    }
                  })
                }
              }

              break;
            case "2": //enabled
              if (enableControlIDS.length == 0) {
                enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (enableCntrIds && enableCntrIds.length > 0) {
                  enableCntrIds.forEach((id) => {
                    if (!enableControlIDS.includes(id)) {
                      enableControlIDS.push(id);
                    }
                  })
                }
              }
              break;
            case "3": //hide
              if (hideControlIDS.length == 0) {
                hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (hideCntrIds && hideCntrIds.length > 0) {
                  hideCntrIds.forEach((id) => {
                    if (!hideControlIDS.includes(id)) {
                      hideControlIDS.push(id);
                    }
                  })
                }
              }

              break;

            case "4": //disabled
              if (disbledControlIDS.length == 0) {
                disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disableCntrIds && disableCntrIds.length > 0) {
                  disableCntrIds.forEach((id) => {
                    if (!disbledControlIDS.includes(id)) {
                      disbledControlIDS.push(id);
                    }
                  })
                }
              }
              break;
          }

        });
      }
    })
    //default
    if (value != "") {
      this.staticformFields.forEach((con) => {

        if (displayControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = true;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (hideControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = false;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (enableControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = true;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (disbledControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = false;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }

      });
    }
    else {
      this.UpdateParentChildDetails(question);
    }

    if (makeNull == "Y") {
      this.staticformFields.forEach((con) => {
        if (con.IS_Dependent_Display == false) {
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "8") {
            con.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            });
          }
          if (con.CONTROL == "6") {
            con.SourceItems.forEach((item) => {
              item.Checked = false;
            });
          }
        }
        if (con.IS_Dependent_Display == true) {

        }
        if (con.IS_Dependent_Enabled == false) {
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "8") {
            con.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            });
          }
          if (con.CONTROL == "6") {
            con.SourceItems.forEach((item) => {
              item.Checked = false;
            });
          }
        }
        if (con.IS_Dependent_Enabled == true) {

        }
      });
    }
  }

  UpdateParentChildDetails(question: any) {
    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }
    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];

    question.Control_Condtions.forEach((item) => {
      item.ConditionsList.forEach((otemCon) => {
        switch (otemCon.Mapped_Condtion) {
          case "1": //display
            if (displayControlIDS.length == 0) {
              displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disCntrIds && disCntrIds.length > 0) {
                disCntrIds.forEach((id) => {
                  if (!displayControlIDS.includes(id)) {
                    displayControlIDS.push(id);
                  }
                })
              }
            }

            break;
          case "2": //enabled

            if (enableControlIDS.length == 0) {
              enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (enableCntrIds && enableCntrIds.length > 0) {
                enableCntrIds.forEach((id) => {
                  if (!enableControlIDS.includes(id)) {
                    enableControlIDS.push(id);
                  }
                })
              }
            }
            break;
          case "3": //hide

            if (hideControlIDS.length == 0) {
              hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (hideCntrIds && hideCntrIds.length > 0) {
                hideCntrIds.forEach((id) => {
                  if (!hideControlIDS.includes(id)) {
                    hideControlIDS.push(id);
                  }
                })
              }
            }
            break;

          case "4": //disabled
            if (disbledControlIDS.length == 0) {
              disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disableCntrIds && disableCntrIds.length > 0) {
                disableCntrIds.forEach((id) => {
                  if (!disbledControlIDS.includes(id)) {
                    disbledControlIDS.push(id);
                  }
                })
              }
            }
            break;
        }
      });
    })

    this.staticformFields.forEach((con) => {
      if (displayControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Display = false;
      }
      if (hideControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Display = true;
      }
      if (enableControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Enabled = false;
      }
      if (disbledControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Enabled = true;
      }
    });

  }
  DateSelect(event, question) {
    this.IsFormToched = true;
    this.isDateModified = true;
    this.Full_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isDateModified
    }
    question.dynamicDateobj = this.Full_Date;
  }

  OpenFile(item: Document_Upload_File): void {
    if (item.Status == "Edit") {
      let Url = serviceConstants.apiURL + "api/screen/downloadfile/" + item.ID;
      window.open(Url);
    }
  }

  ViewFile(fileID, fileName) {
    this.commonService.previewFile(fileID, fileName, "med");
  }

  uploadchange(event, ques: SCREEN_CONTROL): void {
    let Flag = true;
    if (ques.UploadFiles == undefined || ques.UploadFiles == null)
      ques.UploadFiles = [];
    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      let file = event.target.files[i].name;
      let ext = file.match(/\.([^\.]+)$/)[1];
      let filesize = event.target.files[i].size;

      if (file != null && ((filesize > 52428800) || (ext == 'exe'))) {
        Flag = false;
      }
      else {
        this.saveTempFiles(event.target.files[i]).subscribe((result: any) => {
          let uploadFile = new Document_Upload_File();
          uploadFile.ID = result.Data[0].FileID;
          uploadFile.DOCUMENT_NAME = event.target.files[i].name;
          uploadFile.File = null;
          uploadFile.Status = "Add";
          uploadFile.UploadedDate = this.datepipe.transform(new Date().toUTCString(), 'dd-MMM-YYYY');
          let hasValue = ques.UploadFiles.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase() && x.Status != "Delete");
          if (hasValue.length > 0) {
            this.commonService.ValidationBanner("File already exists with " + uploadFile.DOCUMENT_NAME + " Please update the unique file name");
          }
          else if (ques.ISALLOWMULTIPLEFILES) {
            ques.UploadFiles.push(uploadFile);
          } else {
            ques.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            })
            ques.UploadFiles.push(uploadFile);
          }
        });

      }
    }
    if (!Flag)
      this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 50MB");
  }

  saveTempFiles(selectedFiles: any) {
    const formData = new FormData();
    formData.append(`files`, selectedFiles);
    return this.fileService.uploadMultiFiles(formData, "");
  }

  changeVal($event, question) {
    question.NotimesChanged = question.NotimesChanged + 1;
    question.IsTouched = true;
    if (question.NotimesChanged >= 2)
      this.IsFormToched = true;

    setTimeout(() => {
      let selectedControl = question.ControlValue;
      if (selectedControl != "" && selectedControl != undefined && selectedControl != null) {
        let controlLabel = question.SourceItems.filter((item) => {
          return selectedControl.indexOf(item.value) > -1;
        })
        let labellist = [];
        controlLabel.forEach((item) => {
          labellist.push(item.label);
        });
        this.tooltipValue = labellist.join(",");
      }
      else {
        this.tooltipValue = "";
      }

    }, 200);

  }
  DeleteUpload(file, ques: SCREEN_CONTROL): void {
    this.IsFormToched = true;
    let code = file.ID;
    if (file.Status == "Add") {
      ques.UploadFiles = ques.UploadFiles.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      this.commonService.CheckIsFileIsRefereancedInReviw(code).subscribe((x) => {
        if (x["Status"] == 2 && x["Data"] == false) {
          this.commonService.ValidationBanner(x["Message"]);
        }
        else {
          file.Status = "Delete";
        }
      });
    }
  }

  BindDataToStaticControls(MainObjData: any): any {
    for (var i = 0; i < this.staticformFields.length; i++) {
      switch (this.staticformFields[i].FIELD_CODE) {
        case "APPLICATION_TITLE":
          this.staticformFields[i].ControlValue = MainObjData.APPLICATION_TITLE;
          break;
        case "MED_EDU_GRANTS":
          this.staticformFields[i].ControlValue = MainObjData.MED_EDU_GRANTS;
          break;
        case "IS_PREIOR_REQ":
          this.staticformFields[i].ControlValue = MainObjData.IS_PREIOR_REQ;
          break;
        case "IS_AFFILIATE_PRO":
          this.staticformFields[i].ControlValue = MainObjData.IS_AFFILIATE_PRO;
          break;
        case "LAST_REQ_SUBMIT":
          this.staticformFields[i].ControlValue = MainObjData.LAST_REQ_SUBMIT;
          break;
        case "IS_PREV_YEAR":
          this.staticformFields[i].ControlValue = MainObjData.IS_PREV_YEAR;
          break;
        case "IS_EXHIBIT_OPPORTUNITY":
          this.staticformFields[i].ControlValue = MainObjData.IS_EXHIBIT_OPPORTUNITY;
          break;
        case "IS_OTH_CORPORATES":
          this.staticformFields[i].ControlValue = MainObjData.IS_OTH_CORPORATES;
          break;
        case "IS_OTH_CORPORATES_DESC":
          this.staticformFields[i].ControlValue = MainObjData.IS_OTH_CORPORATES_DESC;
          break;
        case "RFP_CODE":
          this.staticformFields[i].ControlValue = MainObjData.RFP_CODE;
          break;
        case "ANNUAL_REVENUE":
          this.staticformFields[i].ControlValue = MainObjData.ANNUAL_REVENUE;
          break;
        case "TOTAL_EMPLOYEES":
          this.staticformFields[i].ControlValue = MainObjData.TOTAL_EMPLOYEES;
          break;
        case "TOTAL_YEARS":
          this.staticformFields[i].ControlValue = MainObjData.TOTAL_YEARS;
          break;
      }

      if (this.staticformFields[i].CONTROL == '4') {
        this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i], "N");
      }
    }
  }

  BindDataToDynamicControls() {
    if (this.ApplicationID != null && this.ApplicationID != undefined && this.ApplicationID != "") {
      let sr = new ScreenResponseModel();
      sr.Id = "GC01";
      sr.RowId = this.ApplicationID;
      sr.AppId = this.ApplicationID;
      this.summaryService.getGrantsScreenResponse(sr).subscribe(summary => {
        this.submittedresponse = summary;
        if (this.submittedresponse != null && this.submittedresponse.length > 0) {
          for (let i = 0; i < this.staticformFields.length; i++) {
            var response = this.submittedresponse.filter(x => x.SCREEN_CONTROL_ID == this.staticformFields[i].ID);

            if (response != null && response.length > 0) {
              if (this.staticformFields[i].CONTROL == '6') {
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                  this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                  var options = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(",");
                  if (this.staticformFields[i].SourceItems != null && this.staticformFields[i].SourceItems != undefined) {
                    for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
                      if (options.indexOf(this.staticformFields[i].SourceItems[c].value) > -1) {
                        this.staticformFields[i].SourceItems[c].Checked = true;
                      }
                      else {
                        this.staticformFields[i].SourceItems[c].Checked = false;
                      }
                    }
                  }

                }
              }
              else if (this.staticformFields[i].CONTROL == '10') {
                this.staticformFields[i].NotimesChanged = 0;
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                  this.staticformFields[i].ControlValue = [];

                  var options1 = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(',');
                  options1.forEach((item) => {
                    this.staticformFields[i].ControlValue.push(item);
                  });
                  this.staticformFields[i].SUBFIELDNAME = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                }
                else {
                  this.staticformFields[i].ControlValue = [];
                }
              }
              else if (this.staticformFields[i].CONTROL == '5') {
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "" && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined) {
                  let formd = new Date(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                  this.staticformFields[i].ControlValue = formd;

                  if (this.staticformFields[i].DATEFORMATE == 'DD-MMM-YYYY') {
                    let formd = this.commonService.getdisplayedDate(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                    this.staticformFields[i].ControlValue = new Date(formd);
                  }

                }

              }
              else {
                this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
              }
              this.staticformFields[i].UploadFiles = response[0].UploadFiles;
              if (this.staticformFields[i].CONTROL == '4') {
                this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i], "N");
              }
            }

          }
        }

      });
    }
  }

  getScreenDataEdit(){
    this.summaryService.getGeneralInformationCME("api/GMAPPCME/Edit?RecordID=" + this.ApplicationID).subscribe((summary) => {
      if (summary != null && summary != undefined) {

        this.createdUser = summary["RECORD_CREATED_BY"];
        this.status = summary["STATUS"];
        if(summary["RECORD_CREATED_BY"] == null){
          this.IsRecordSaved = false;
        }
        else{
          this.IsRecordSaved = true;
        }

        if((summary["SUBMIT_STATUS"] == 1 ) || (this.user.ID == summary["RECORD_CREATED_BY"]) || this.isSubmitVisible == false ){
          this.Id = summary["ID"];
          this.BindDataToDynamicControls();
          this.BindDataToStaticControls(summary);
          this.ScreenSubmitStatus = summary["SUBMIT_STATUS"] == 1 ? true : false;
        }
        if(this.Grantsapp?.STATUS > 1 && summary["SUBMIT_STATUS"] == 1){
          this.disableSave = true;
        }

        if(!this.isSubmitVisible){
          this.disableSave = false;
        }
      }
    });
  }
}
